import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class GetAllUserBoughtLessons extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("UserBoughtLesson/GetList");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

export { GetAllUserBoughtLessons };
